import type { ComponentType } from 'react'
import {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Award,
  BarChart3,
  Bell,
  BellOff,
  Bookmark,
  BookmarkCheck,
  Box,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarDays,
  Camera,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  Clipboard,
  Clock,
  Coffee,
  Command,
  Compass,
  Copy,
  Cpu,
  CreditCard,
  Crosshair,
  Crown,
  Database,
  Disc,
  DollarSign,
  Download,
  Droplet,
  Edit,
  Eye,
  EyeOff,
  File,
  FileImage,
  FileText,
  Filter,
  Flag,
  Flame,
  Folder,
  FolderOpen,
  Gamepad2,
  Gauge,
  Gem,
  Ghost,
  Gift,
  GitBranch,
  GitCommit,
  Github,
  Gitlab,
  GitMerge,
  GitPullRequest,
  Globe,
  GraduationCap,
  Grid,
  HardDrive,
  Hash,
  Headphones,
  Heart,
  HelpCircle,
  Hexagon,
  Home,
  Image,
  Info,
  Inbox,
  Key,
  Laptop,
  Layers,
  LayoutGrid,
  LifeBuoy,
  Lightbulb,
  Link,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  MicOff,
  Minimize,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  MousePointer,
  Move,
  Music,
  Navigation,
  Octagon,
  Package,
  Paperclip,
  ClipboardPaste,
  Pause,
  PauseCircle,
  Phone,
  Play,
  PlayCircle,
  Plus,
  Power,
  Printer,
  Radio,
  RefreshCw,
  Repeat,
  Rewind,
  RotateCcw,
  RotateCw,
  Rss,
  Save,
  Scissors,
  Search,
  Server,
  Settings,
  Share,
  Shield,
  ShieldCheck,
  ShoppingCart,
  SkipBack,
  SkipForward,
  Sliders,
  Smartphone,
  Smile,
  SortAsc,
  SortDesc,
  Speaker,
  Square,
  Star,
  StopCircle,
  Sun,
  Tag,
  Tags,
  Tablet,
  Target,
  Terminal,
  ThumbsDown,
  ThumbsUp,
  ToggleLeft,
  ToggleRight,
  TrendingUp,
  Trophy,
  Truck,
  Trash,
  Trash2,
  Tv,
  Type,
  Umbrella,
  Unlock,
  Upload,
  User,
  UserPlus,
  Users,
  Video,
  Volume,
  Volume1,
  Volume2,
  VolumeX,
  Wallet,
  Watch,
  Wifi,
  WifiOff,
  Wind,
  Wrench,
  X,
  XCircle,
  Youtube,
  Zap,
  ZoomIn,
  ZoomOut,
  Maximize,
} from 'lucide-react'

// Lista específica de ícones disponíveis
export const AVAILABLE_ICONS = [
  'Activity',
  'Airplay',
  'AlertCircle',
  'AlertTriangle',
  'Archive',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'Award',
  'BarChart3',
  'Bell',
  'BellOff',
  'Bookmark',
  'BookmarkCheck',
  'Box',
  'Briefcase',
  'Building',
  'Building2',
  'Calendar',
  'CalendarDays',
  'Camera',
  'Check',
  'CheckCircle',
  'ChevronDown',
  'ChevronLeft',
  'ChevronRight',
  'ChevronUp',
  'Circle',
  'Clipboard',
  'Clock',
  'Coffee',
  'Command',
  'Compass',
  'Copy',
  'Cpu',
  'CreditCard',
  'Crosshair',
  'Crown',
  'Database',
  'Disc',
  'DollarSign',
  'Download',
  'Droplet',
  'Edit',
  'Eye',
  'EyeOff',
  'File',
  'FileImage',
  'FileText',
  'Filter',
  'Flag',
  'Flame',
  'Folder',
  'FolderOpen',
  'Gamepad2',
  'Gauge',
  'Gem',
  'Ghost',
  'Gift',
  'GitBranch',
  'GitCommit',
  'Github',
  'Gitlab',
  'GitMerge',
  'GitPullRequest',
  'Globe',
  'GraduationCap',
  'Grid',
  'HardDrive',
  'Hash',
  'Headphones',
  'Heart',
  'HelpCircle',
  'Hexagon',
  'Home',
  'Image',
  'Info',
  'Inbox',
  'Key',
  'Laptop',
  'Layers',
  'LayoutGrid',
  'LifeBuoy',
  'Lightbulb',
  'Link',
  'Loader',
  'Lock',
  'LogIn',
  'LogOut',
  'Mail',
  'MapPin',
  'Megaphone',
  'Menu',
  'MessageCircle',
  'MessageSquare',
  'Mic',
  'MicOff',
  'Minimize',
  'Minus',
  'Monitor',
  'Moon',
  'MoreHorizontal',
  'MoreVertical',
  'MousePointer',
  'Move',
  'Music',
  'Navigation',
  'Octagon',
  'Package',
  'Paperclip',
  'ClipboardPaste',
  'Pause',
  'PauseCircle',
  'Phone',
  'Play',
  'PlayCircle',
  'Plus',
  'Power',
  'Printer',
  'Radio',
  'RefreshCw',
  'Repeat',
  'Rewind',
  'RotateCcw',
  'RotateCw',
  'Rss',
  'Save',
  'Scissors',
  'Search',
  'Server',
  'Settings',
  'Share',
  'Shield',
  'ShieldCheck',
  'ShoppingCart',
  'SkipBack',
  'SkipForward',
  'Sliders',
  'Smartphone',
  'Smile',
  'SortAsc',
  'SortDesc',
  'Speaker',
  'Square',
  'Star',
  'StopCircle',
  'Sun',
  'Tag',
  'Tags',
  'Tablet',
  'Target',
  'Terminal',
  'ThumbsDown',
  'ThumbsUp',
  'ToggleLeft',
  'ToggleRight',
  'TrendingUp',
  'Trophy',
  'Truck',
  'Trash',
  'Trash2',
  'Tv',
  'Type',
  'Umbrella',
  'Unlock',
  'Upload',
  'User',
  'UserPlus',
  'Users',
  'Video',
  'Volume',
  'Volume1',
  'Volume2',
  'VolumeX',
  'Wallet',
  'Watch',
  'Wifi',
  'WifiOff',
  'Wind',
  'Wrench',
  'X',
  'XCircle',
  'Youtube',
  'Zap',
  'ZoomIn',
  'ZoomOut',
  'Maximize',
] as const

// Mapeamento de nomes para componentes
const iconMap: Record<string, ComponentType<any>> = {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Award,
  BarChart3,
  Bell,
  BellOff,
  Bookmark,
  BookmarkCheck,
  Box,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarDays,
  Camera,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  Clipboard,
  Clock,
  Coffee,
  Command,
  Compass,
  Copy,
  Cpu,
  CreditCard,
  Crosshair,
  Crown,
  Database,
  Disc,
  DollarSign,
  Download,
  Droplet,
  Edit,
  Eye,
  EyeOff,
  File,
  FileImage,
  FileText,
  Filter,
  Flag,
  Flame,
  Folder,
  FolderOpen,
  Gamepad2,
  Gauge,
  Gem,
  Ghost,
  Gift,
  GitBranch,
  GitCommit,
  Github,
  Gitlab,
  GitMerge,
  GitPullRequest,
  Globe,
  GraduationCap,
  Grid,
  HardDrive,
  Hash,
  Headphones,
  Heart,
  HelpCircle,
  Hexagon,
  Home,
  Image,
  Info,
  Inbox,
  Key,
  Laptop,
  Layers,
  LayoutGrid,
  LifeBuoy,
  Lightbulb,
  Link,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  MicOff,
  Minimize,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  MousePointer,
  Move,
  Music,
  Navigation,
  Octagon,
  Package,
  Paperclip,
  ClipboardPaste,
  Pause,
  PauseCircle,
  Phone,
  Play,
  PlayCircle,
  Plus,
  Power,
  Printer,
  Radio,
  RefreshCw,
  Repeat,
  Rewind,
  RotateCcw,
  RotateCw,
  Rss,
  Save,
  Scissors,
  Search,
  Server,
  Settings,
  Share,
  Shield,
  ShieldCheck,
  ShoppingCart,
  SkipBack,
  SkipForward,
  Sliders,
  Smartphone,
  Smile,
  SortAsc,
  SortDesc,
  Speaker,
  Square,
  Star,
  StopCircle,
  Sun,
  Tag,
  Tags,
  Tablet,
  Target,
  Terminal,
  ThumbsDown,
  ThumbsUp,
  ToggleLeft,
  ToggleRight,
  TrendingUp,
  Trophy,
  Truck,
  Trash,
  Trash2,
  Tv,
  Type,
  Umbrella,
  Unlock,
  Upload,
  User,
  UserPlus,
  Users,
  Video,
  Volume,
  Volume1,
  Volume2,
  VolumeX,
  Wallet,
  Watch,
  Wifi,
  WifiOff,
  Wind,
  Wrench,
  X,
  XCircle,
  Youtube,
  Zap,
  ZoomIn,
  ZoomOut,
  Maximize,
}

export const getIconComponent = (iconName: string): ComponentType<any> | null => {
  if (!iconName || typeof iconName !== 'string') return null
  return iconMap[iconName] || null
}

export const getAllIcons = (): string[] => {
  return [...AVAILABLE_ICONS].sort()
}
